var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1949_9301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58885 4.02357L4.52317 8.08925C4.3362 8.27622 4.19305 8.50234 4.10403 8.75132C4.01502 9.00031 3.98236 9.26594 4.00842 9.52906C4.03448 9.79219 4.11859 10.0463 4.25471 10.2729C4.39082 10.4996 4.57554 10.6933 4.79555 10.84L7.76829 12.8218C8.1382 13.0684 8.40292 13.444 8.51075 13.8753L9.74756 18.8226C9.78591 18.976 9.86428 19.1165 9.97468 19.2297C10.0851 19.3429 10.2235 19.4248 10.3759 19.467C10.5283 19.5092 10.6892 19.5102 10.8421 19.47C10.995 19.4297 11.1345 19.3495 11.2463 19.2377L19.7373 10.7467C19.8491 10.6349 19.9293 10.4954 19.9695 10.3425C20.0098 10.1896 20.0088 10.0287 19.9666 9.87634C19.9244 9.72394 19.8425 9.58548 19.7293 9.47509C19.6161 9.36469 19.4756 9.28632 19.3222 9.24797L14.3749 8.01115C13.9436 7.90332 13.568 7.6386 13.3214 7.26869L11.3396 4.29595C11.1929 4.07594 10.9992 3.89122 10.7725 3.75511C10.5459 3.61899 10.2918 3.53488 10.0287 3.50882C9.76554 3.48276 9.49991 3.51542 9.25092 3.60443C9.00194 3.69345 8.77582 3.8366 8.58885 4.02357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5L15.4922 14.9922",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1949_9301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPin);
export default __webpack_public_path__ + "static/media/ic_pin.921962506f1b9e9ff99ed27731932395.svg";
export { ForwardRef as ReactComponent };